module.exports = __webpack_public_path__ + "static/media/oberflex-frakebariolet311-2560x1440.2cc31abc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-frakebariolet311-2560x1440.jpg
// module id = 1019
// module chunks = 37